import { Capacitor } from '@capacitor/core';

// Native (Capacitor Android/iOS): the app serves its bundle from the local
// webview, so there is no CRA proxy and relative URLs point nowhere. Talk to
// production over HTTPS directly, authenticating with a Bearer token (see
// utils/tokenManager). This is evaluated at runtime in the webview, so the web
// build is unaffected (isNativePlatform() is false there).
const isNative = (() => {
  try {
    return typeof window !== 'undefined' && Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
})();

// Native (Capacitor) API base. The shipped app serves its bundle locally and
// talks to production over HTTPS with a Bearer token.
// EXCEPTION — LAN live-reload dev: when capacitor.config's dev-only `server.url`
// points the webview at the dev server (http://192.168.x:3000), API calls must
// hit THAT origin (→ CRA proxy → local dev backend), not production. Detected by
// the private-LAN origin, so this is automatically inert in the shipped app
// (its origin is capacitor://localhost, never a 192.168.x / 10.x address).
const NATIVE_API_BASE = (() => {
  try {
    const origin = window.location.origin;
    if (/^https?:\/\/(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(origin)) {
      return origin;
    }
  } catch { /* fall through to production */ }
  return 'https://vegetablah.com';
})();

// WEB: REACT_APP_API_URL set to '' (empty) makes all requests relative to the
// page origin, so the CRA dev-server proxy (package.json "proxy") carries them
// to the backend — required for LAN dev where only port 3000 is reachable.
const API_URL = isNative
  ? NATIVE_API_BASE
  : (process.env.REACT_APP_API_URL ?? 'http://localhost:8000');

export const API_CONFIG = {
  BASE_URL: API_URL,
  UPLOADS_BASE_URL: `${API_URL}/uploads`,
  TIMEOUT: 30000, // 30 seconds
  WITH_CREDENTIALS: true
};

// Validate production configuration
if (process.env.NODE_ENV === 'production' && !API_CONFIG.BASE_URL.startsWith('https://')) {
  console.error('Production API must use HTTPS');
  throw new Error('Invalid API configuration for production');
}

export default API_CONFIG;

